import React,{useEffect} from 'react'

import './Aicte.css'

import { ContentCard,Underline } from '../../widgets'

import {EOA_reports} from '../../constants/aicte'

const Aicte = () => {
  useEffect(() => {
    document.title = 'ACCET-AICTE';
  }, []);
  return (
    <div className='aicte_content'>
        {/* <div className='aicte_head'>AICTE Attachments</div> */}
        <Underline heading="AICTE Attachments"/>
        <div className='aicte_cards'>
            {EOA_reports.map((item)=><ContentCard key={item.id} heading={item.program} pdf={item.pdf}/>)}
        </div>
    </div>
  )
}

export default Aicte